import {
  ChatDots,
  FileMagnifyingGlass,
  Files,
  Flag,
  Note,
  PencilSimple,
  SneakerMove,
} from '@phosphor-icons/react';
import { FormattedMessage } from 'react-intl';

import { DownloadOptions } from '../../../../interfaces/DownloadOptions';

import { Checkbox } from '~/components/ui/checkbox';

interface CustomizeOptionsProps {
  options: DownloadOptions;
  setOptions: React.Dispatch<React.SetStateAction<DownloadOptions>>;
}

const CustomizeOptions = ({ options, setOptions }: CustomizeOptionsProps) => {
  const CUSTOMIZE_OPTION_LOGO_WIDTH = 28;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = event.target;
    setOptions((prevOptions) => ({
      ...prevOptions,
      [name]: checked,
    }));
  };

  return (
    <div className='flex flex-col w-4/5 mx-auto gap-4'>
      <div className='flex flex-row justify-between w-full'>
        <div className='flex flex-row items-center gap-4'>
          <FileMagnifyingGlass size={CUSTOMIZE_OPTION_LOGO_WIDTH} />
          <p className='text-base'>
            <FormattedMessage defaultMessage='Case Details' />
          </p>
        </div>
        <Checkbox
          checked={options.details}
          name='details'
          onChange={handleChange}
        />
      </div>
      <div className='flex flex-row justify-between w-full'>
        <div className='flex flex-row items-center gap-4'>
          <ChatDots size={CUSTOMIZE_OPTION_LOGO_WIDTH} />
          <p className='text-base'>
            <FormattedMessage defaultMessage='Messages' />
          </p>
        </div>
        <Checkbox
          checked={options.messages}
          name='messages'
          onChange={handleChange}
        />
      </div>
      <div className='flex flex-row justify-between w-full'>
        <div className='flex flex-row items-center gap-4'>
          <ChatDots size={CUSTOMIZE_OPTION_LOGO_WIDTH} />
          <p className='text-base'>
            <FormattedMessage defaultMessage='RFI Messages' />
          </p>
        </div>
        <Checkbox
          checked={options.rfiMessages}
          name='rfiMessages'
          onChange={handleChange}
        />
      </div>
      <div className='flex flex-row justify-between w-full'>
        <div className='flex flex-row items-center gap-4'>
          <PencilSimple size={CUSTOMIZE_OPTION_LOGO_WIDTH} />
          <p className='text-base'>
            <FormattedMessage defaultMessage='Notes' />
          </p>
        </div>
        <Checkbox
          checked={options.notes}
          name='notes'
          onChange={handleChange}
        />
      </div>
      <div className='flex flex-row justify-between w-full'>
        <div className='flex flex-row items-center gap-4'>
          <SneakerMove size={CUSTOMIZE_OPTION_LOGO_WIDTH} />
          <p className='text-base'>
            <FormattedMessage defaultMessage='Actions Taken' />
          </p>
        </div>
        <Checkbox
          checked={options.actions}
          name='actions'
          onChange={handleChange}
        />
      </div>
      <div className='flex flex-row justify-between w-full'>
        <div className='flex flex-row items-center gap-4'>
          <Flag size={CUSTOMIZE_OPTION_LOGO_WIDTH} />
          <p className='text-base'>
            <FormattedMessage defaultMessage='Final Report' />
          </p>
        </div>
        <Checkbox
          checked={options.finalReport}
          name='finalReport'
          onChange={handleChange}
        />
      </div>
      <div className='flex flex-row justify-between w-full'>
        <div className='flex flex-row items-center gap-4'>
          <Note size={CUSTOMIZE_OPTION_LOGO_WIDTH} />
          <p className='text-base'>
            <FormattedMessage defaultMessage='Audit Logs' />
          </p>
        </div>
        <Checkbox
          checked={options.audit}
          name='audit'
          onChange={handleChange}
        />
      </div>
      <div className='flex flex-row justify-between w-full'>
        <div className='flex flex-row items-center gap-4'>
          <Files size={CUSTOMIZE_OPTION_LOGO_WIDTH} />
          <p className='text-base'>
            <FormattedMessage defaultMessage='Files' />
          </p>
        </div>
        <Checkbox
          checked={options.files}
          name='files'
          onChange={handleChange}
        />
      </div>
    </div>
  );
};

export default CustomizeOptions;
